// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2kq7w","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1xwLE"};